import { Component, DestroyRef, Input, OnChanges, OnInit, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Config } from "@cbcore/services/config/config.service";
import { LinkService } from "@cbcore/services/utils/links/links.service";
import { ConfigurationState } from '@cbcore/NGRX/configuration/configuration.models';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppState, selectConfiguration } from '@cbcore/NGRX/core.state';
import { Store } from '@ngrx/store';
import { isEqual } from "lodash-es";
import { ImagesLazyLoadDirective } from '../../../helpers/directives/images-lazy-load';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';

@Component({
    selector: 'widget-pool-recommended',
    templateUrl: './pool-recommended.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PipesModule,
    TranslocoModule,
    CommonModule,
    
        ImagesLazyLoadDirective
    ]
})
export class WidgetPoolRecommendedComponent implements OnInit, OnChanges {
  @Input() bannerImage!: string; // Always bound by its only real consumer
  @Input() bannerPath!: string; // Always bound by its only real consumer
  public displayState: any;
  public poolListWidget?: string; // Never assigned anywhere; not read in the template either
  public imagesUrl!: string; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public clickable?: boolean; // Only assigned when bannerPath is present

  private configuration$!: Observable<ConfigurationState>; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  private destroyRef = inject(DestroyRef);

  constructor(
    private _config: Config,
    private _router: Router,
    private _linkService: LinkService,
    private store: Store<AppState>
  ) {
  }

  ngOnInit(): void {
    this.configuration$ = this.store.select(selectConfiguration);
    this.configuration$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(configuration => {
      this.displayState = configuration.displayState;
    });

    this.imagesUrl = this._config.CONFIG.imagesUrl;
    this.bannerImage = `${this.imagesUrl}${this.bannerImage}`;
    if (this.bannerPath) this.clickable = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bannerImage) {
      if (!changes.bannerImage.firstChange) {
        this.bannerImage = changes.bannerImage.currentValue;
      }
    }
    if (changes.bannerPath) {
      if (!changes.bannerPath.firstChange) {
        this.bannerPath = changes.bannerPath.currentValue;
      }
    }
  }

  openLink() {
    if (!this.bannerPath) return;

    if (this.bannerPath.includes('https')) {
      this._linkService.openLink(this.bannerPath);
    } else {
      this._router.navigate([this.bannerPath]);
    }
  }
}
